'use strict';

var _breakpoints = require('../helpers/breakpoints');

var _breakpoints2 = _interopRequireDefault(_breakpoints);

require('lazysizes/plugins/object-fit/ls.object-fit');

require('lazysizes/plugins/parent-fit/ls.parent-fit');

require('lazysizes/plugins/rias/ls.rias');

require('lazysizes/plugins/bgset/ls.bgset');

require('lazysizes');

require('lazysizes/plugins/respimg/ls.respimg');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.lazySizesConfig = window.lazySizesConfig || {}; /**
                                                        * Helper: Lazysizes
                                                        * ------------------------------------------------------------------------------
                                                        * Loosely coupled scripts for responsive and lazy loading images.
                                                        *
                                                        * @namespace lazysizes
                                                        */

window.lazySizesConfig.customMedia = {
  '--tiny': '(min-width: ' + _breakpoints2.default.tiny + ')',
  '--small': '(min-width: ' + _breakpoints2.default.small + ')',
  '--medium': '(min-width: ' + _breakpoints2.default.medium + ')',
  '--large': '(min-width: ' + _breakpoints2.default.large + ')',
  '--wide': '(min-width: ' + _breakpoints2.default.wide + ')'
};